export default __webpack_public_path__ + "0733a5daba00ba4ddbdac114b2f7b94a.svg";